module.exports = __webpack_public_path__ + "img/assets/triangle-corner--medium.svg";